import { Routes, Route } from 'react-router-dom'
import Layout from '@/components/Layout/Layout'
import HomePage from '@/pages/HomePage'
import SkillNexusPage from '@/pages/SkillNexusPage'
import InternNexusPage from '@/pages/InternNexusPage'
import PromptNexusPage from '@/pages/PromptNexusPage'
import EcosystemPage from '@/pages/EcosystemPage'
import AmbassadorPage from '@/pages/AmbassadorPage'
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage'
import TermsConditionsPage from '@/pages/TermsConditionsPage'
import NotFoundPage from '@/pages/NotFoundPage'
import InstallPWABanner from '@/components/InstallPWA/InstallPWA'

export default function App() {
  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="skillnexus" element={<SkillNexusPage />} />
          <Route path="internnexus" element={<InternNexusPage />} />
          <Route path="promptnexus" element={<PromptNexusPage />} />
          <Route path="ecosystem" element={<EcosystemPage />} />
          <Route path="ambassador" element={<AmbassadorPage />} />
          <Route path="privacy" element={<PrivacyPolicyPage />} />
          <Route path="terms" element={<TermsConditionsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      <InstallPWABanner />
    </>
  )
}
